/*
 * assets/js/src/recenze.js — „Zobrazit celé" u recenzí z Googlu.
 *
 * Text recenze je zkrácený na pět řádků (`-webkit-line-clamp`). Tlačítko
 * má smysl JEN u těch, které se do pěti řádků opravdu nevešly — u ostatních
 * by slibovalo pokračování, které neexistuje.
 *
 * Proto je tlačítko v HTML `hidden` a modul ho odkryje až po změření
 * (`scrollHeight > clientHeight`). Bez skriptu tedy tlačítko není a text
 * zůstane zkrácený; celý je pořád dostupný na Googlu odkazem v hrdinovi.
 */

export function init() {
	const karty = [...document.querySelectorAll('.revgrid .rev')];
	if (!karty.length) return 0;

	let odkryto = 0;
	for (const karta of karty) {
		const text = karta.querySelector('p');
		const btn = karta.querySelector('.morebtn');
		if (!text || !btn) continue;
		if (text.scrollHeight <= text.clientHeight + 1) continue;

		btn.hidden = false;
		btn.setAttribute('aria-expanded', 'false');
		odkryto += 1;
		btn.addEventListener('click', () => {
			karta.classList.add('cele');
			btn.setAttribute('aria-expanded', 'true');
			btn.remove();
		});
	}
	return odkryto;
}
